import { useState } from "react";
import { Trash2, Upload } from "lucide-react";
import { toast } from "sonner";
import { resolveMediaUrl, uploadMedia } from "../../../lib/api";

export const SecondaryImagesEditor = ({ images, onChange }) => {
  const [uploading, setUploading] = useState(false);

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const { url } = await uploadMedia(file, "image");
      onChange([...images, url]);
      toast.success("Fotografía secundaria agregada");
    } catch {
      toast.error("Error al subir la fotografía");
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  const removeAt = (idx) => onChange(images.filter((_, i) => i !== idx));

  return (
    <div className="space-y-3">
      {images.length > 0 && (
        <div className="grid grid-cols-3 md:grid-cols-4 gap-3">
          {images.map((img, idx) => (
            <div key={`${img}-${idx}`} className="relative group" data-testid={`seo-secondary-image-item-${idx}`}>
              <img src={resolveMediaUrl(img)} alt="" className="h-24 w-full object-cover rounded" />
              <button
                data-testid={`seo-secondary-image-remove-${idx}`}
                onClick={() => removeAt(idx)}
                className="absolute top-1 right-1 bg-black/70 text-white p-1 rounded opacity-0 group-hover:opacity-100 transition-opacity"
              >
                <Trash2 size={12} />
              </button>
            </div>
          ))}
        </div>
      )}
      <label
        data-testid="seo-secondary-image-upload-label"
        className="flex items-center gap-2 border-2 border-dashed rounded-lg px-4 py-3 cursor-pointer hover:bg-secondary/50 text-sm w-fit"
      >
        <Upload size={16} /> {uploading ? "Subiendo..." : "Agregar fotografía secundaria"}
        <input
          data-testid="seo-secondary-image-upload-input"
          type="file"
          accept="image/*"
          className="hidden"
          onChange={handleUpload}
          disabled={uploading}
        />
      </label>
    </div>
  );
};
